import { atomWithStorage } from 'jotai/utils';

export const cuaWakeAssertionEnabledAtom = atomWithStorage(
  'heidi:cua-wake-assertion-enabled',
  false,
  undefined,
  { getOnInit: true }
);

cuaWakeAssertionEnabledAtom.debugLabel = 'cuaWakeAssertionEnabledAtom';
